<!-- 公司详情页 -->
<template>
  <div class="company-wrap">
    <div class="header-wrap">
      <div class="icon">
        <comp-icon
          :src="detailData.compLogo"
          :width="70"
          :height="70"
        ></comp-icon>
      </div>
      <div class="des">
        <div>{{ detailData.compName }}</div>
        <div>企业通号：{{ detailData.compMdt }}</div>
      </div>
    </div>
    <div class="descript">
      <div class="item-des">主营产品：{{ detailData.mainProduct }}</div>
      <div class="item-des">类型：外协企业</div>
      <div class="item-des">企业等级：{{ detailData.level }}</div>
      <div class="item-des">联系电话：{{ detailData.phone }}</div>
      <div class="item-des">邮箱：{{ detailData.email }}</div>
      <div class="item-des">传真：{{ detailData.fax }}</div>
      <div class="item-des">成立日期：{{ detailData.info && detailData.info.createdAt }}</div>
      <div class="item-des">详细地址：{{ detailData.province }}{{ detailData.city }}{{ detailData.district }}{{ detailData.address }}</div>
    </div>
  </div>
</template>

<script>
import { ProductService } from '@/service/outsource'
import CompIcon from "/@/components/icon/comp-icon.vue";

export default {
  components: {
    CompIcon
  },
  props: {
    id: {
      type: Number
    }
  },
  data () {
    return {
      detailData: {}
    }
  },
  mounted(){
    this.getDetail()
  },
  methods: {
    async getDetail() {
      const res = await ProductService.getCompanyInfo(this.id)
      this.detailData = res.data
    }
  }
}
</script>


<style scoped lang="less">
.company-wrap {
  padding: 0 20px;
  color: #484141;
  font-size: 14px;

  .header-wrap {
    display: flex;
    align-items: center;
    .icon {
      width: 70px;
      height: 70px;
      border-radius: 8px;
      margin-right: 15px;
    }
    .des {
      font-size: 16px;
      line-height: 28px;
      color: #333;
      & > div:last-child {
        margin-top: 5px;
        font-size: 14px;
        color: #484141;
      }
    }
  }
  .descript {
    .item-des {
      margin-top: 20px;
    }
  }
  .introduce {
    margin-top: 15px;
    line-height: 30px;
  }
}
</style>
